import request from '@/utils/request'


// 获取我的概念报告历史
export function getConceptList(data) {
    return request({
        url: '/dev-api/quartz/concept/list',
        headers: {
            isToken: false
        },
        method: 'get',
        params: data,
        timeout: 20000
    })
}

// 模拟沙盘
export function getInterfaceSpeed(data) {
    return request({
        url: '/dev-api/system/baiDuSpeed/interfaceSpeed',
        headers: {
            isToken: false
        },
        method: 'get',
        params: data,
        timeout: 3000000
    })
}

// 获取html
export function getHtml(data) {
    return request({
        url: '/dev-api/knowledge/completions',
        headers: {
            isToken: false
        },
        method: "get",
        params: data,
        timeout: 300000
    })
}

// 新增沙盘记录
export function addSandTableRecord(data) {
    return request({
        url: '/dev-api/system/sandTableRecord/add',
        method: 'post',
        data: data
    })
}

// 更新沙盘记录（回答时间等）
export function editSandTableRecord(data) {
    return request({
        url: '/dev-api/system/sandTableRecord/edit',
        method: 'put',
        data: data
    })
}

// 新增图谱记录
export function addGraphRecord(data) {
    return request({
        url: '/dev-api/system/graphRecord/add',
        method: 'post',
        data: data
    })
}

// 更新图谱记录
export function editGraphRecord(data) {
    return request({
        url: '/dev-api/system/graphRecord/edit',
        method: 'put',
        data: data
    })
}

// 新增智启通记录
export function addZhiQiTongRecord(data) {
    return request({
        url: '/dev-api/system/zhiQiTong/add',
        method: 'post',
        data: data
    })
}

// 更新智启通记录
export function editZhiQiTongRecord(data) {
    return request({
        url: '/dev-api/system/zhiQiTong/edit',
        method: 'put',
        data: data
    })
}

// 新增概念报告记录
export function addConceptRecord(data) {
    return request({
        url: '/dev-api/system/concept/add',
        method: 'post',
        data: data
    })
}

// 更新概念报告记录
export function editConceptRecord(data) {
    return request({
        url: '/dev-api/system/concept/edit',
        method: 'put',
        data: data
    })
}

// 新增巡检报告记录
export function addFormRecord(data) {
    return request({
        url: '/dev-api/system/selfInspection/add',
        method: 'post',
        data: data
    })
}

// 更新巡检报告记录
export function editFormRecord(data) {
    return request({
        url: '/dev-api/system/selfInspection/edit',
        method: 'put',
        data: data
    })
}

